import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import usePrevious from '../../hooks/usePrevious';
import VoucherManagement from '../../components/voucher/VoucherManagement';
import { fetchVoucherCode, fetchTrialAndSurvey } from '../../redux/actions';
import { RootState, TrialCategoryValue } from '../../redux/types';
import { useAppDispatch } from '../../hooks/reduxHooks';

type MatchParams = {
  name: string;
  trialId: string;
}

const VoucherManagementView: React.FC = () => {
  const params = useParams<MatchParams>();
  const { trialId } = params;
  const prevTrialId = usePrevious<string|undefined>(trialId);
  const dispatch = useAppDispatch();
  const voucherData = useSelector((state: RootState) => state.voucher?.voucherData);
  const trial = useSelector((state: RootState) => state.trial?.trial);
  useEffect(() => {
    if (!voucherData || trialId !== prevTrialId) {
      dispatch(fetchVoucherCode(Number(trialId)));
    }
    if (!trial
      || (prevTrialId !== undefined && trialId !== prevTrialId)
      || Number(trialId) !== trial.id) {
      dispatch(fetchTrialAndSurvey(Number(trialId)));
    }
  }, [dispatch, trial, voucherData, trialId, prevTrialId]);
  return (
    <>
      {
        trial && trial.trialCategory === TrialCategoryValue.voucherTrial
        && <VoucherManagement trial={trial} voucherData={voucherData} />
      }
      {
        trial && trial.trialCategory !== TrialCategoryValue.voucherTrial
        && <h2><FormattedMessage id="voucher.incompatible" /></h2>
      }
    </>
  );
};

export default VoucherManagementView;
